export const styles = {
  logo: {
    height: "45px",
  },
};
